import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ApiClient from "#/redux/api/ApiClient";
import { getErrorMessage } from "#/utils/APIUtils";

const baseUrl = "/api/dog/kopitar/pripust/sezona";

export const createPripustnaSezona = createAsyncThunk(
  "pripustnaSezona/create",
  async (pripustnaSezona, { rejectWithValue }) => {
    try {
      const response = await ApiClient.post(baseUrl, pripustnaSezona);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const updatePripustnaSezona = createAsyncThunk(
  "pripustnaSezona/update",
  async ({ id, pripustnaSezona }, { rejectWithValue }) => {
    try {
      const response = await ApiClient.put(`${baseUrl}/${id}`, pripustnaSezona);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const deletePripustnaSezona = createAsyncThunk(
  "pripustnaSezona/delete",
  async ({ id, version }, { rejectWithValue }) => {
    try {
      const response = await ApiClient.delete(`${baseUrl}/${id}`, { version });
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const getPripustnaSezonaById = createAsyncThunk(
  "pripustnaSezona/get",
  async (id, { rejectWithValue }) => {
    try {
      const response = await ApiClient.get(`${baseUrl}/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const getPripustnaSezonaPage = createAsyncThunk(
  "pripustnaSezona/page",
  async ({ page, filter, sort }, { rejectWithValue }) => {
    try {
      const response = await ApiClient.get(
        `${baseUrl}/page`,
        undefined,
        page,
        filter,
        sort,
        false
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

const pripustnaSezonaSlice = createSlice({
  name: "pripustnaSezona",
  initialState: {
    content: null,
    page: {},
    byId: {},
    error: null,
    isLoading: false,
  },
  reducers: {
    clearPripustnaSezonaDetails: (state) => {
      state.content = null;
      state.error = null;
      state.isLoading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createPripustnaSezona.fulfilled, (state, action) => {
        state.isLoading = false;
        state.content = action.payload;
      })
      .addCase(createPripustnaSezona.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(createPripustnaSezona.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updatePripustnaSezona.fulfilled, (state, action) => {
        state.isLoading = false;
        state.content = action.payload;
      })
      .addCase(updatePripustnaSezona.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(updatePripustnaSezona.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getPripustnaSezonaById.fulfilled, (state, action) => {
        state.isLoading = false;
        state.content = action.payload;
        state.byId[action.payload.id] = action.payload;
      })
      .addCase(getPripustnaSezonaById.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(getPripustnaSezonaById.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getPripustnaSezonaPage.fulfilled, (state, action) => {
        state.isLoading = false;
        state.page = action.payload;
      })
      .addCase(getPripustnaSezonaPage.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(getPripustnaSezonaPage.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(deletePripustnaSezona.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(deletePripustnaSezona.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(deletePripustnaSezona.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearPripustnaSezonaDetails } = pripustnaSezonaSlice.actions;
export default pripustnaSezonaSlice.reducer;
